/**
 * @description
 * Objeto notices
 */

import { Texts } from "./texts.model";

export class Notices {
    public id:number = null;
    public code:string = "";
    public title: Texts = new Texts();
    public description: Texts = new Texts();
    public text_button: Texts = new Texts();
    public image:string;
    public link:string;
    public enable:number=null;
    public order:number=null;

    constructor() {}
  
}